import { Component, Input, Output, EventEmitter } from "@angular/core";
declare var Survey: any;

@Component({
  selector: "survey",
  template: `<div class="survey-container contentcontainer codecontainer">
    <div id="surveyElement"></div>
  </div>`,
})
export class SurveyComponent {
  @Input() json: any;
  @Output()
  public complete = new EventEmitter<any>();
  surveyModel;

  ngOnInit() {
    this.surveyModel = new Survey.ReactSurveyModel(this.json);
    // Survey.StylesManager.applyTheme("bootstrap");
    // Survey.defaultBootstrapCss.navigationButton = "btn btn-success-filled";
    // Survey.defaultBootstrapCss.footer = "text-center";
    this.surveyModel.onComplete.add((result) => {
      this.complete.emit({ result: result.data });
    });
    Survey.SurveyNG.render("surveyElement", { model: this.surveyModel });
  }

  public completeLastPage() {
    this.surveyModel.completeLastPage();
  }
}
